import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { WarningAmber } from '@mui/icons-material';

const ShpFileWarningModal = ({
  open,
  onClose,
  title = '.shp file warning',
  message = 'Please zip your .shp file with all associated files before uploading.',
  okButtonText = 'Ok',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '.MuiDialog-paper': {
          width: '510px',
          boxShadow:
            '0px 8px 10px -5px rgba(0, 0, 0, 0.2),0px 16px 24px 2px rgba(0, 0, 0, 0.14),0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          borderBottom: '1px solid rgba(0, 37, 71, 0.12)',
        }}
      >
        <WarningAmber
          sx={{ color: 'rgba(211, 47, 47, 1)', width: '24px', height: '24px' }}
        />
        <div className='text-heading-style-1'>{title}</div>
      </DialogTitle>
      <DialogContent sx={{ padding: '20px 24px !important' }}>
        <div className='normal-text-style-2' style={{ lineHeight: '28px' }}>
          {message}
        </div>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button
          variant='contained'
          onClick={onClose}
          className='error-contained-button-medium'
        >
          {okButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShpFileWarningModal;
